const CART_COOKIE_NAME = "cartCountCookie";
const CART_MAX_ITEMS = 999;
const ICON_SIZE_LG = "30px";
const ICON_SIZE_MD = "24px";
const ICON_SIZE_SM = "22px";
const BADGE_HEIGHT_WIDTH = "16px";
export {
  BADGE_HEIGHT_WIDTH,
  CART_COOKIE_NAME,
  CART_MAX_ITEMS,
  ICON_SIZE_LG,
  ICON_SIZE_MD,
  ICON_SIZE_SM
};
